export const contestCategories = [
  // { id: 1, name: 'DEFAULT' },
  { id: 2, name: 'IMPORT' },
];
export const options = [
  { name: 'Active', value: true },
  { name: 'Inactive', value: false },
];
export const visibility = [
  { id: 1, name: 'DEALERSHIP' },
  { id: 2, name: 'GROUP' },
  { id: 3, name: 'GLOBAL' },
];
export const contestDurationTypes = [
  { id: 1, name: 'DAILY' },
  { id: 2, name: 'WEEKLY' },
  { id: 3, name: 'MONTHLY' },
  { id: 4, name: 'YEARLY' },
];

export const dealershipSortOptions = [
  { id: 1, name: 'Dealership ID' },
  { id: 2, name: 'Dealership Name' },
];

export const orderByList = [
  { id: 'ASC', name: 'Ascending Order' },
  { id: 'DESC', name: 'Descending Order' },
];

export const bottomSheetMenuList = [{ name: 'Remove' }];
